import * as React from "react";
import { AlertDialog } from "../components/AlertDialog";

const AlertServiceContext = React.createContext();

export const useAlert = () =>
  React.useContext(AlertServiceContext);

const AlertServiceProvider = ({ children }) => {
  const [
    alertState,
    setAlertState
  ] = React.useState(null);

  const awaitingPromiseRef = React.useRef();

  const openAlert = (options) => {
    setAlertState(options);
    return new Promise((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = () => {
    if (alertState.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }

    setAlertState(null);
  };

  const handleSubmit = () => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }

    setAlertState(null);
  };

  return (
    <>
      <AlertServiceContext.Provider
        value={openAlert}
        children={children}
      />

      <AlertDialog
        open={Boolean(alertState)}
        onSubmit={handleSubmit}
        onClose={handleClose}
        {...alertState}
      />
    </>
  );
};


export default AlertServiceProvider;